/** Shared sidebar + mobile drawer navigation */

import { APP_ROUTES } from "../constants/appRoutes";

export const SIDEBAR_ITEM_ACCESS = {
    PUBLIC: "public",
    AUTHENTICATED: "authenticated",
};

export const SIDEBAR_DISABLED_REASON = {
    AUTH_REQUIRED: "auth_required",
    COMING_SOON: "coming_soon",
};

const DEFAULT_ACCESS = SIDEBAR_ITEM_ACCESS.PUBLIC;

export const sidebarMenuItems = [
    {
        icon: "bi bi-house",
        name: "Home",
        path: APP_ROUTES.HOME,
        cta: "nav_home",
        access: SIDEBAR_ITEM_ACCESS.PUBLIC,
    },
    {
        icon: "bi bi-graph-up",
        name: "Campaigns",
        path: APP_ROUTES.CAMPAIGNS,
        cta: "nav_campaigns",
        access: SIDEBAR_ITEM_ACCESS.AUTHENTICATED,
    },
    {
        icon: "bi bi-pencil-square",
        name: "Posts",
        path: APP_ROUTES.POSTS,
        cta: "nav_posts",
        access: SIDEBAR_ITEM_ACCESS.AUTHENTICATED,
    },
];

export const sidebarToolsItems = [
    {
        icon: "bi bi-megaphone",
        name: "Post Builder",
        path: APP_ROUTES.CAMPAIGN_WIZARD,
        cta: "nav_campaign_builder",
        aiBadge: true,
        access: SIDEBAR_ITEM_ACCESS.PUBLIC,
    },
    {
        icon: "bi bi-fire",
        name: "What's Trending",
        path: APP_ROUTES.CONTENT_AI,
        cta: "nav_content_intelligence",
        access: SIDEBAR_ITEM_ACCESS.PUBLIC,
    },
    // {
    //   icon: "bi bi-calendar3",
    //   name: "Post Calendar",
    //   path: "/post-calendar",
    //   disabled: true,
    //   comingSoon: true,
    // },
    // {
    //   icon: "bi bi-robot",
    //   name: "Automation",
    //   path: "/automation",
    //   disabled: true,
    //   comingSoon: true,
    // },
];

export const sidebarSettingsItems = [
    {
        icon: "bi bi-person-circle",
        name: "Profile",
        path: APP_ROUTES.PROFILE,
        cta: "nav_profile",
        access: SIDEBAR_ITEM_ACCESS.AUTHENTICATED,
    },
    {
        icon: "bi bi-sliders",
        name: "Preferences",
        path: APP_ROUTES.SETTINGS,
        cta: "nav_settings",
        access: SIDEBAR_ITEM_ACCESS.AUTHENTICATED,
    },
    {
        icon: "bi bi-credit-card",
        name: "Payments",
        path: APP_ROUTES.PAYMENTS,
        cta: "nav_payments",
        access: SIDEBAR_ITEM_ACCESS.AUTHENTICATED,
    },
];

export const sidebarNavSections = [
    { id: "menu", label: "Menu", items: sidebarMenuItems },
    { id: "tools", label: "Tools", items: sidebarToolsItems },
    { id: "settings", label: "Settings", items: sidebarSettingsItems },
];

function requiresAuthentication(item) {
    return (item.access ?? DEFAULT_ACCESS) === SIDEBAR_ITEM_ACCESS.AUTHENTICATED;
}

export function resolveSidebarNavItem(item, { isAuthenticated }) {
    if (item.comingSoon) {
        return {
            ...item,
            disabled: true,
            disabledReason: SIDEBAR_DISABLED_REASON.COMING_SOON,
            disabledTitle: "Coming soon",
        };
    }

    if (requiresAuthentication(item) && !isAuthenticated) {
        return {
            ...item,
            disabled: true,
            disabledReason: SIDEBAR_DISABLED_REASON.AUTH_REQUIRED,
            disabledTitle: "Log in to access",
        };
    }

    return {
        ...item,
        disabled: Boolean(item.disabled),
        disabledReason: item.disabled ? SIDEBAR_DISABLED_REASON.COMING_SOON : null,
        disabledTitle: item.disabled ? "Unavailable" : null,
    };
}

export function resolveSidebarNavSections(sections, { isAuthenticated }) {
    return sections.map((section) => ({
        ...section,
        items: section.items.map((item) => resolveSidebarNavItem(item, { isAuthenticated })),
    }));
}

/** @deprecated Use sidebarNavSections */
export const sidebarNavItems = [
    ...sidebarMenuItems,
    ...sidebarToolsItems,
    ...sidebarSettingsItems,
];
